import React from 'react';
import cx from 'classnames';
import './Item.css';

export default ({logo, header, children, left, middle, right}) => {
    const classes = cx({
        'how-much-item': true,
        'how-much-item-l': left,
        'how-much-item-m': middle,
        'how-much-item-r': right
    });
    return(
        <div className={classes}>
            <img
                src={logo}
            />
            <div>
                {header}
            </div>
            <div>
                {children}
            </div>
        </div>
    );
}